var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadaccountchart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77783 10.8889V12.8889C1.77783 13.2426 1.91831 13.5817 2.16836 13.8318C2.4184 14.0818 2.75754 14.2223 3.11117 14.2223H12.4445C12.7981 14.2223 13.1373 14.0818 13.3873 13.8318C13.6374 13.5817 13.7778 13.2426 13.7778 12.8889V10.8889M5.11117 7.55561L7.77783 10.2223M7.77783 10.2223L10.4445 7.55561M7.77783 10.2223V1.77783",
    stroke: "#393945",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadaccountchart);
export default __webpack_public_path__ + "static/media/downloadaccountchart.9e9e1688.svg";
export { ForwardRef as ReactComponent };